import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import SEO from "./SEO";

const Layout = () => (
  <div className="app-shell"><SEO /><Header /><main><Outlet /></main><Footer /></div>
);

export default Layout;
